module.exports = __webpack_public_path__ + "static/media/IMG-6.7f883a5f.jpg";